import { Box, Stack, Typography } from "@mui/material";
import { SectionHeading } from "../../../components/SectionHeading";

const values = ["Movimento", "Evolução", "Personalidade"];

export function Essence() {
  return (
    <Box component="section" sx={{ textAlign: "center" }}>
      <SectionHeading overline="Essência" title="O que a Groowv representa" />

      <Stack direction="row" spacing={2} useFlexGap sx={{ mt: { xs: -2, md: -4 }, flexWrap: "wrap", justifyContent: "center" }}>
        {values.map((value) => (
          <Box
            key={value}
            sx={{
              px: 3,
              py: 1.25,
              borderRadius: 999,
              border: "1px solid",
              borderColor: "primary.main",
              color: "primary.main",
              fontSize: 14,
              fontWeight: 600,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
            }}
          >
            {value}
          </Box>
        ))}
      </Stack>

      <Typography
        sx={{
          mt: { xs: 5, md: 6 },
          mx: "auto",
          maxWidth: 760,
          color: "text.secondary",
          fontSize: { xs: "1.05rem", md: "1.2rem" },
          lineHeight: 1.8,
        }}
      >
        A Groowv representa movimento, evolução e personalidade. Um projeto que valoriza a essência de cada
        instrumento, a conexão entre os músicos e a energia que nasce quando o ritmo encontra a emoção.
      </Typography>
    </Box>
  );
}
